import CardProject from '../../components/items/CardProject'

import expertNotes from '../../img/projects/expertNotes.png'
import react from '../../img/technology/react.png'
import html from '../../img/technology/html.png'
import css from '../../img/technology/css.png'
import typeScript from '../../img/technology/typescript.png'

export default function Project6() {
  return (
    <div>
      <CardProject
        name="Expert Notes"
        img={expertNotes}
        text="O Expert Notes é um projeto apaixonante criado durante o evento NLW da Rocketseat, voltado para entusiastas de tecnologia e desenvolvimento web. Desenvolvido com React e TypeScript, este aplicativo de bloco de notas oferece uma plataforma intuitiva para organizar pensamentos e ideias. Utilizando conceitos modernos de design e UX, o Expert Notes proporciona uma experiência fluida e responsiva em todos os dispositivos. Integrando recursos avançados de armazenamento local, os usuários podem acessar suas notas de forma rápida e segura. Seja para anotar insights de programação ou registrar pensamentos criativos, o Expert Notes é a ferramenta essencial para estudantes e profissionais em busca de organização e produtividade."
        app="https://nlw-expert-notes-zeta-rust.vercel.app/"
        repo="https://github.com/RiccettoDev/nlw-expert-notes"
        technology1={react}
        nameTechnology1="React JS"
        technology2={html}
        nameTechnology2="HTML"
        technology3={css}
        nameTechnology3="CSS"
        technology4={typeScript}
        nameTechnology4="TypeScript"
      />
    </div>
  )
}
